module.exports = __webpack_public_path__ + "img/Arrival Data.976a0200.svg";